"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthCheckControlInteractor = void 0;
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const rxjs_1 = require("rxjs");
const HealthCheckHarmonizationManager_1 = require("../../HealthCheckHarmonizationManager");
const helpers_1 = require("../../helpers");
require("../../types");
class HealthCheckControlInteractor extends core_1.Interactor {
    constructor(form, texts, models) {
        super();
        this.form = form;
        this.texts = texts;
        this.models = models;
        this.subscriptions = new rxjs_1.Subscription();
        this.isAvailable = (isBackupEnabled) => {
            return this.harmonizationManager.isAvailable(isBackupEnabled);
        };
        this.isFieldControlVisible = () => {
            return this.mainModel.getValue().isEnabled;
        };
        this.isFieldDayOfMonthVisible = () => {
            return this.harmonizationManager.isDayOfMonthControlVisible();
        };
        this.isFieldDayOfWeekVisible = () => {
            return this.harmonizationManager.isDayOfWeekControlVisible();
        };
        this.isFieldMonthSelectable = () => {
            return this.harmonizationManager.isMonthSelectable();
        };
        this.getFieldDayNumberInMonthOptions = () => {
            return helpers_1.getTextOptionsList(this.harmonizationManager.getDayNumberInMonthData(), this.texts);
        };
        this.getFieldDayOfMonthOptions = () => {
            return this.harmonizationManager.getDayOfMonthData();
        };
        this.getFieldDayOfWeekOptions = () => {
            return helpers_1.getTextOptionsList(this.harmonizationManager.getDayOfWeekData(), this.texts);
        };
        this.getFieldMonthOptions = () => {
            return helpers_1.getTextOptionsList(this.harmonizationManager.getMonthsData(), this.texts);
        };
        this.texts = texts;
        this.form = form;
        this.mainModel = form.model;
        this.models = models;
        this.harmonizationManager = new HealthCheckHarmonizationManager_1.HealthCheckHarmonizationManager(this.mainModel, this.models);
        this.columns = helpers_1.getDailyColumns();
        this.scheduleMatrixLegendFooter = components_1.createSchedulingMatrixLegendFooter({
            texts: {
                label: this.texts.matrixFooterSelectModeLabel,
                selectMode: this.texts.matrixFooterSelectModeSelectLabel,
                unselectMode: this.texts.matrixFooterSelectModeUnselectLabel,
            },
        });
        this.fieldDayNumberInMonthComboboxModel = new core_1.Model(this.getFieldDayNumberInMonthOptions());
        this.fieldDayOfMonthComboboxModel = new core_1.Model(this.getFieldDayOfMonthOptions());
        this.fieldDayOfWeekComboboxModel = new core_1.Model(this.getFieldDayOfWeekOptions());
        this.fieldMonthComboboxModel = new core_1.Model(this.getFieldMonthOptions());
    }
    didActivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.form.hideError('fieldDayNumberInMonthValue');
            this.form.hideError('fieldDayOfMonthValue');
            this.form.hideError('fieldDayOfWeekValue');
            this.form.hideError('fieldMonthValue');
            this.subscriptions.add(this.mainModel.fieldChanges('fieldDayNumberInMonthValue').subscribe(() => {
                const dailyScheduleModelValue = this.models.dailyScheduleModel.getValue();
                const weeklyScheduleModelValue = this.models.weeklyScheduleModel.getValue();
                if (dailyScheduleModelValue.isEnabled || weeklyScheduleModelValue.isEnabled) {
                    this.fieldDayOfWeekComboboxModel.setValue(this.getFieldDayOfWeekOptions());
                }
            }));
        });
    }
    willDeactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.unsubscribe();
        });
    }
}
exports.HealthCheckControlInteractor = HealthCheckControlInteractor;
//# sourceMappingURL=HealthCheckControlInteractor.js.map